var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('vs-tabs',[(_vm.AdminBodega || _vm.userRoot)?_c('vs-tab',{attrs:{"label":"Movimiento no operativo"}},[_c('movimientosProducto')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }